import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { AgendaKeuze, type Aanbieders } from './MijnAgenda';

/** Agenda koppelen via de koppellink uit de mail, zonder account (SPEC §8.3). */
export function Koppelen() {
  const { token } = useParams();
  const [q] = useSearchParams();
  const klaar = q.get('gekoppeld') === '1';
  const fout = q.get('fout');
  const info = useQuery({
    queryKey: ['koppelen', token],
    queryFn: () => api.get<{ engineer: string; organisatie: string; aanbieders: Aanbieders }>(`/api/koppelen/${token}`),
    retry: false,
    enabled: !klaar,
  });
  return (
    <div className="midden">
      <div className="paneel login kolom" style={{ maxWidth: 520 }}>
        <div className="rij"><img src="/favicon.svg" width={30} alt="" /><h2>Agenda koppelen</h2></div>
        {klaar && <div style={{ fontSize: 16 }}>✅ Je agenda is gekoppeld. Je taken, verlof en vrije dagen verschijnen er binnen een paar minuten in. Je kunt dit venster sluiten.</div>}
        {!klaar && fout && <div className="paneel vlak" style={{ background: 'var(--rood-bg)' }}>Koppelen mislukt: {fout}</div>}
        {!klaar && info.isLoading && <div className="mute">Laden…</div>}
        {!klaar && info.error && <div style={{ color: 'var(--rood)' }}>{(info.error as Error).message}</div>}
        {!klaar && info.data && (
          <>
            <p>
              Hoi {info.data.engineer}, <b>{info.data.organisatie}</b> plant je werk met bsmartr. Koppel je agenda, dan komen je taken, verlof en vrije dagen er automatisch in te staan en houdt de planning rekening met je afspraken.
            </p>
            <p className="klein mute">Er wordt alleen gelezen of je vrij of bezet bent; de inhoud van je eigen afspraken wordt niet opgeslagen. Je kunt de koppeling altijd weer laten verbreken.</p>
            <AgendaKeuze aanbieders={info.data.aanbieders} uitnodiging={token} />
          </>
        )}
      </div>
    </div>
  );
}
